import { useEffect, useState } from 'react';
import { ShopArray } from '../fetch/fetchInbound';
import { fetchShopArray } from '../fetch/fetchShopArray';

export function useGetShopArray(): {
  shopArrayList: ShopArray[];
  isLoading: boolean;
} {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [shopArrayList, setShopArrayList] = useState<ShopArray[]>(null);

  useEffect(() => {
    const fetchShopArrayMethod = async () => {
      const shopArrayListResult = await fetchShopArray();

      setShopArrayList(shopArrayListResult);
      setIsLoading(false);
    };

    fetchShopArrayMethod();
  }, [setIsLoading]);

  return { shopArrayList, isLoading };
}
